webpackJsonp([124057718056174],{

/***/ 89:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _gatsbyLink = __webpack_require__(59);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Qui consulter ? | Psychologue clinicienne Montpellier au quartier des arceaux | Morgane Laroche',
	  description: "Soins psychiques : différents professionnels. Quels sont-ils ? Quels sont leurs champs et leurs modalités d'intervention ? Quelles formations ont-ils suivies ?"
	};
	
	var QuiConsulter = function QuiConsulter() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container container--page' },
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container__block' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'container__block-title' },
	        'QUI CONSULTER ?'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Couramment, beaucoup se questionnent sur ce qui diff\xE9rencie le psychologue du psychiatre, du psychanalyste et du psychoth\xE9rapeute. Ces fonctions ne sont pas antinomiques. En effet, il est possible d\u2019avoir le titre de psychologue ou de psychiatre et d\u2019\xEAtre \xE0 la fois psychanalyste.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Si ces professionnels occupent une fonction commune consistant \xE0 entendre et accompagner l\'individu dans sa dimension psychique, ils diff\xE9rent sur plusieurs points sur lesquels je vous propose de revenir bri\xE8vement.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe u-mb' },
	        'Mieux les conna\xEEtre vous permettra de mieux choisir le professionnel qui pourra r\xE9pondre \xE0 votre demande.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'La psychiatrie'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe u-mb' },
	        'Il s\u2019agit d\u2019une ',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'discipline m\xE9dicale'
	        ),
	        ' qui s\u2019int\xE9resse aux maladies mentales (diagnostic, pronostic et traitement) et leur pr\xE9vention. Le psychiatre, de par son titre et son statut de m\xE9decin est autoris\xE9 \xE0 prescrire un traitement m\xE9dicamenteux.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'La psychoth\xE9rapie'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'La psychoth\xE9rapie est une',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'modalit\xE9 de prise en charge psychologique'
	        ),
	        ' ',
	        'd\u2019une souffrance psychique. Elle peut s\u2019adresser \xE0 un individu, mais aussi \xE0 un groupe d\u2019individus. Cette souffrance peut provenir d\u2019un d\xE9s\xE9quilibre purement psychologique ou s\u2019exprimer comme la r\xE9percussion d\u2019un \xE9v\xE9nement autre (deuil, rupture, annonce de diagnostic, traumatisme \u2026)'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe u-mb' },
	        'Depuis 2010, l\'usage du titre de psychoth\xE9rapeute est r\xE9glement\xE9. Pour pr\xE9tendre au titre, il faut remplir certaines conditions (obtention d\'un dipl\xF4me de psychologie, de m\xE9decine, etc.) \xE9nonc\xE9es dans le D\xE9cret n\xB02010-534 et obtenir l\'autorisation d\'usage. Celle ci est d\xE9livr\xE9e par l\'Agence R\xE9gionale de la Sant\xE9.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'La psychanalyse'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Le terme \xAB psychanalyse \xBB que l\u2019on doit \xE0 Sigmund Freud, son fondateur, traduit un',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'proc\xE9d\xE9 d\u2019investigation psychologique des processus inconscients'
	        ),
	        '. Autrement dit, il s\u2019agit d\u2019une m\xE9thode th\xE9rapeutique et d\u2019un ensemble de connaissances th\xE9oriques qui rendent compte d\u2019un fonctionnement psychique.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Il s\u2019agit d\u2019une approche parmi d\u2019autres : syst\xE9mie, ph\xE9nom\xE9nologie, th\xE9rapies cognitivo-comportementales, hypnoth\xE9rapie ...'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'En France, son titre n\u2019est pas prot\xE9g\xE9. En revanche, il est possible de se former \xE0 la psychanalyse en devenant membre d\u2019une soci\xE9t\xE9 psychanalytique, impliquant comme condition',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-italic' },
	          'sine qua non'
	        ),
	        ' l\u2019exp\xE9rience de son analyse personnelle.'
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: 'container__block-subtitle container__block-subtitle--highlighted' },
	        'La psychologie'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe u-mb' },
	        'Consulter la page "',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: 'container__block-link',
	            to: '/psychologie'
	          },
	          'Qu\'est ce qu\'un psychologue clinicien ?'
	        ),
	        '".'
	      )
	    )
	  );
	};
	exports.default = QuiConsulter;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-qui-consulter-js-11c811e62118a5a27ac5.js